<template>
    <div class="account-warpper">
        <div class="bg-white ">
            <div class="flex align-center justify-end">
                <el-button type="primary" @click="editItem(false)">添加</el-button>
            </div>
            <el-table v-loading="loading" :data="list" class="margin-top-sm" header-row-class-name="table-header"
                row-class-name="table-row" alig="center" border style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column label="积分" prop="score" width="220"></el-table-column>
                <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button size="small" type="primary" @click="editItem(scope.row)">编辑
                            </el-button>
                            <el-button size="small" type="primary" @click="delItem(scope.row.id)">删除
                            </el-button>
                        </div>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <add-service-dialog :dialog="addDialog" :item="cur_item" @cancelDialog="cancelDialog"></add-service-dialog>
    </div>
</template>

<script>

import { delNewProjectService, getProjectServiceList } from "@/api/weilao";
import AddServiceDialog from "@/views/pages/dialog/addServiceDialog";

export default {
    name: "server-type",
    data() {
        return {
            list: [],
            addDialog: false,
            cur_item: '',
            loading: false
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老 / 服务类别", false);
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: { AddServiceDialog },
    methods: {
        async init() {
            this.loading = true
            let _data = await getProjectServiceList();
            this.loading = false
            this.list = _data.data
        },
        editItem(data) {
            this.cur_item = data
            this.addDialog = true
        },
        cancelDialog(data) {
            if (data) this.init()
            this.addDialog = false
        },
        delItem(id) {
            this.$confirm('您确定要删除该服务吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDel(id);
            });
        },
        async sureDel(id) {
            let _state = await delNewProjectService(id);
            this.init();
            this.$message.success(_state.info);
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss"></style>
